"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayNameMaxLength = exports.displayNameMinLength = exports.loginMaxLength = exports.loginMinLength = exports.lastNameMaxLength = exports.lastNameMinLength = exports.firstNameMaxLength = exports.firstNameMinLength = exports.emailMaxLength = exports.passwordMaxLength = exports.passwordMinLength = exports.passwordScore = void 0;
exports.passwordScore = 1;
exports.passwordMinLength = 8;
exports.passwordMaxLength = 40;
exports.emailMaxLength = 40;
exports.firstNameMinLength = 2;
exports.firstNameMaxLength = 40;
exports.lastNameMinLength = 2;
exports.lastNameMaxLength = 40;
exports.loginMinLength = 2;
exports.loginMaxLength = 40;
exports.displayNameMinLength = 2;
exports.displayNameMaxLength = 50;
//# sourceMappingURL=validation.js.map